export default __webpack_public_path__ + "static/media/payment-terms.34f86268.svg";